import MDBox from "../../Components/MDBox";
import React from "react";
import MDTypography from "../../Components/MDTypography";
import {ButtonBase, Grid, makeStyles, Stack} from "@mui/material";
import PageLayout from "../../Components/LayoutContainers/PageLayout";

import G1 from '../../Asset/images/g1.png'

import {useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import StarImage from "../../Asset/images/StarImage.png";
import CloudImage from "../../Asset/images/cloudy.png";
import PplImage from "../../Asset/images/peopl.png";
import FruitImage from "../../Asset/images/fruie.png";
import StdImg from "../../Asset/images/std.png";
import Pezeshk from "../../Asset/images/pezeshk.png";
import Morabi from "../../Asset/images/morabii.png";
import Valed from "../../Asset/images/valed.png";
import Sun from "../../Asset/images/sunbb.png";
import Abrha from "../../Asset/images/abrha.png";
import TelegramIcon from "../../Asset/images/teleg.png";
import GmailIcon from "../../Asset/images/gma.png";
import PhoneIcon from "../../Asset/images/pho.png";

function Home() {
    const navigate = useNavigate();
    return <PageLayout background={"radial-gradient(circle,rgba(198, 243, 255, 1) 0%, rgba(238, 251, 255, 1) 100%)"}>
        <MDBox sx={{
            minHeight: {xs: '50vh', md: '100vh', lg: '100vh'},
            position: "relative",
            overflow: "hidden"
        }}>
            <MDBox
                component="img"
                src={StarImage}
                alt="star"
                sx={{
                    position: 'absolute',
                    top: 0,
                    right: '0',
                    transform: 'translateX(10%)',
                    width: {xs: '15vh', md: '60vh', lg: '60vh'},
                    height: {xs: '30vh', md: '60vh', lg: '60vh'},
                }}
            /> <MDBox
            component="img"
            src={CloudImage}
            alt="star"
            sx={{
                position: 'absolute',
                top: 0,
                left: '0',
                // transform: 'translateX(10%)',
                width: {xs: '15vh', md: '60vh', lg: '60vh'},
                height: {xs: '30vh', md: '60vh', lg: '60vh'},
            }}
        />
            <MDBox sx={{
                position: 'absolute',
                left: '50%',
                top: "10vh",
                width: "100%",
                transform: 'translateX(-50%)',

            }}>
                <MDTypography
                    align="center"
                    sx={{
                        color: '#251F8B',
                        fontSize: {xs: '40px', md: '85px', lg: '85px'},
                        fontWeight: "bold",
                        fontFamily: "lale",
                        zIndex: 10
                    }}
                >
                    قهرمان سلامت
                </MDTypography>
                <MDTypography
                    align="center"
                    sx={{
                        color: '#251F8B',
                        mt: "-15px",
                        fontSize: {xs: '20px', md: '35px', lg: '35px'},
                        fontWeight: "bold",
                        fontFamily: "lale",
                        zIndex: 10

                    }}
                >
                    سلامت دانش آموزان ، سرمایه ای برای آینده
                </MDTypography>

            </MDBox>
            <MDBox
                component="img"
                src={PplImage}
                alt="star"
                sx={{
                    position: 'absolute',
                    bottom: 0,
                    left: '50%',
                    transform: 'translate(-50%,15px)',
                    width: {xs: '100%', md: '70%', lg: '70%'},
                    height: {xs: '30vh', md: '60vh', lg: '60vh'},
                    zIndex: 1

                }}
            />
        </MDBox>
        <MDBox
        >
            <MDBox sx={{
                background: "#FFC300",
                width: {xs: '98vw', md: '98vw', lg: '70vw'},
                height: "50vh",
                justifySelf: "center",
                position: 'relative',
                borderRadius: {xs: '10px', md: '45px', lg: '45px'}
            }}>
                <MDBox
                    component="img"
                    src={FruitImage}
                    alt="star"
                    sx={{
                        position: 'absolute',
                        bottom: 0,
                        left: '50%',
                        transform: 'translate(-50%)',
                        width: {xs: '100%', md: '100%', lg: '100%'},
                        height: {xs: '100%', md: '100%', lg: '100%'},
                        zIndex: 1,


                    }}
                />
                <MDTypography
                    sx={{
                        p: 2,
                        width: {xs: '85%', md: '80%', lg: '80%'},
                        color: 'black',
                        fontSize: {xs: "1.2rem", md: '1.8rem', lg: '2rem'},
                        fontFamily: "vazir",
                        zIndex: 10,
                        placeSelf: "end",
                        position:"sticky"
                    }}
                >

                    چاقی فقط به معنی چاق بودن نیست؛ می‌تونه انرژی‌تون رو بگیره، باعث بشه تو ورزش‌ها کم بیارید یا زود
                    خسته بشید. حتی ممکنه باعث بشه تو جمع‌ها اعتماد به نفس کمتری داشته باشید. ولی با انتخاب غذاهای بهتر و
                    یکم تحرک بیشتر، می‌شه زندگی شادتر و پرانرژی‌تری داشت. از الان برای خودت قوی‌تر قدم بردار!
                </MDTypography>
            </MDBox>
        </MDBox>

            <MDBox sx={{justifyItems: "center", py: 5}}>
                <MDTypography
                    sx={{
                        color: 'black',
                        fontSize: {xs: "1.2rem", md: '1.8rem', lg: '2.125rem'},
                        fontFamily: "vazir",
                        fontWeight: "bold",
                        textAlign:"center",
                        px: {xs: "20px", md: '0', lg: '0'},
                    }}>
                    برای ثبت اطلاعات در وبسایت
                    <span style={{color: "red"}}> {" "}
                        قهرمان سلامت
                        {" "}</span>
                    برروی یکی از عناوین زیر کلیک کنید
                </MDTypography>
            </MDBox>
        
            <MDBox>
                <Grid container columnSpacing={"30px"}>
                    <Grid item xs={12} md={6} lg={6} sx={{textAlign: "end", cursor: "pointer"}} onClick={() => navigate("/login")}>
                        <MDBox
                            component={"img"}
                            sx={{
                                width: {xs: '100%', md: '60%', lg: '60%'},
                                height: {xs: '80%', md: '80%', lg: '80%'}
                            }} 
                            src={StdImg}
                         
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}  sx={{textAlign: "start", cursor: "pointer"}}
                          onClick={() => navigate("/login")}>
                        <MDBox
                            component={"img"}
                            sx={{
                                width: {xs: '100%', md: '60%', lg: '60%'},
                                height: {xs: '80%', md: '80%', lg: '80%'}
                            }}
                            src={Pezeshk}
                    
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}  sx={{textAlign: "end", cursor: "pointer"}} onClick={() => navigate("/login")}>
                        <MDBox
                            component={"img"}
                            sx={{
                                width: {xs: '100%', md: '60%', lg: '60%'},
                                height: {xs: '80%', md: '80%', lg: '80%'}
                            }}
                            src={Valed}
                    
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={6}  sx={{textAlign: "start", cursor: "pointer"}} onClick={() => navigate("/login")}>
                        <MDBox
                            component={"img"}
                            sx={{
                                width: {xs: '100%', md: '60%', lg: '60%'},
                                height: {xs: '80%', md: '80%', lg: '80%'}
                            }}
                            src={Morabi}
                        
                        />
                    </Grid>
                </Grid>
            </MDBox>
        
            <MDBox textAlign={"center"} sx={{marginBottom: "-30px"}}>
                <MDBox
                    component={"img"}
                    sx={{
                        width: {xs: '40%', md: '20%', lg: '20%'},
                     }}
                    src={Sun}
                    
                />

            </MDBox>
            <MDBox bgColor={"#FFC300"} sx={{
                width: {xs: '98%', md: '70%', lg: '70%'},
                justifySelf: "center",
                textAlign: "center",
                px: {xs:1, md: 5, lg: 5},
                pt: {xs:5, md: 10, lg: 10},
                pb: {xs:5, md: 20, lg: 20},
                borderRadius: {xs: '10px', md: '40px', lg: '40px'}
            }}>
                <MDTypography
                    sx={{
                        color: 'black',
                        fontSize: {xs: "1.2rem", md: '1.8rem', lg: '2rem'},
                        fontFamily: "vazir",
                    }}>
                    "ما به سلامت دانش‌آموزان اهمیت می‌دهیم و همواره در کنار شما هستیم. با بهره‌گیری از دانش روز و
                    تخصصی‌ترین
                    ابزارها، مسیر رشد سالم و پایش منظم را برای فرزندانتان فراهم کرده‌ایم. برای کسب اطلاعات بیشتر یا
                    ارتباط
                    با تیم پشتیبانی ما، از طریق راه‌های ارتباطی زیر اقدام کنید."
                </MDTypography>
            </MDBox>
        
            <MDBox textAlign={"center"} sx={{
                marginTop:{xs: "-50px", md: '-100px', lg: '-120px'},
                marginLeft: {xs: "30vh", md: '30vh', lg: '90vh'}
                }}>
                <MDBox
                    component={"img"}
                    sx={{
                        width: {xs: '140px', md: '300px', lg: '300px'},
                    }}
                    src={Abrha}
                 />

            </MDBox>
            <MDBox>
                <Grid container spacing={5} direction={"row-reverse"}>
                    <Grid item xs={6} textAlign={"start"}>
                        <MDBox
                            component={"img"}
                            sx={{
                                width: {xs: '45px', md: '90px', lg: '90px'},
                            }}
                            src={TelegramIcon}  />
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} alignContent={"center"}>
                        <MDTypography sx={{
                            color: 'black',
                            fontSize:  {xs: "1rem", md: '1.2rem', lg: '1.6rem'},
                            fontFamily: "vazir",
                            fontWeight: "bold"
                        }}>09121127744</MDTypography>
                    </Grid>
                    <Grid item xs={6} textAlign={"start"}>
                        <MDBox
                            component={"img"}
                            sx={{
                                width: {xs: '45px', md: '90px', lg: '90px'},
                            }} src={PhoneIcon}  />
                    </Grid>
                    <Grid item xs={6} textAlign={"end"} alignContent={"center"}>
                        <MDTypography sx={{
                            color: 'black',
                            fontSize:  {xs: "1rem", md: '1.2rem', lg: '1.6rem'},
                            fontFamily: "vazir",
                            fontWeight: "bold"
                        }}>09121127744</MDTypography>
                    </Grid> <Grid item xs={6} textAlign={"start"}>
                    <MDBox
                        component={"img"}
                        sx={{
                            width: {xs: '45px', md: '90px', lg: '90px'},
                        }} src={GmailIcon}  />
                </Grid>
                    <Grid item xs={6} textAlign={"end"} alignContent={"center"}>
                        <MDTypography sx={{
                            color: 'black',
                            fontSize:  {xs: "0.9rem", md: '1.2rem', lg: '1.6rem'},
                            fontFamily: "vazir",
                            fontWeight: "bold"
                        }}>ghahremansalamat@gmail.com</MDTypography>
                    </Grid>
                </Grid>
            </MDBox>
        
    </PageLayout>
}

export default Home;